import { CircularProgress, Grid, MenuItem } from '@mui/material';
import React, { ChangeEvent } from 'react';
import { ShipmentDetailsProps } from '../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/parkinglistTypes';
import { transports } from '../../../../../utils/appconstants';
import CustomTextField from '../../../../CustomTextInput';

const TransportDetails = ({
    errors,
    payload,
    countries,
    updateField,
    isCountriesLoading
}: ShipmentDetailsProps) => {
    return (
        <Grid container>
            <Grid item xs={12} md={12} lg={6}>
                <div className='lg:border lg:border-appcolorgreyfaint lg:px-[1rem] lg:pt-[1.1rem] lg:pb-4'>
                    <Grid
                        container
                        spacing={1}
                        sx={{
                            marginTop: '0px'
                        }}
                    >
                        <Grid item xs={12} md={12} lg={6}>
                            <CustomTextField
                                select
                                error={errors?.transport.length > 0}
                                helperText={
                                    errors?.transport.length > 0
                                        ? errors?.transport
                                        : undefined
                                }
                                required
                                value={payload.transport}
                                id='commercialinvoice-transport'
                                label='Transport'
                                name='transport'
                                onChange={(
                                    e: ChangeEvent<HTMLInputElement>
                                ) => {
                                    updateField('transport', e.target.value);
                                }}
                            >
                                {transports.map((item, index) => (
                                    <MenuItem
                                        value={item}
                                        key={`transports-${item}-${index}`}
                                    >
                                        {item}
                                    </MenuItem>
                                ))}
                            </CustomTextField>
                        </Grid>

                        <Grid item xs={12} md={12} lg={6}>
                            <div className='mt-4 lg:mt-0'>
                                <CustomTextField
                                    error={errors?.voyageNumber.length > 0}
                                    helperText={
                                        errors?.voyageNumber.length > 0
                                            ? errors?.voyageNumber
                                            : undefined
                                    }
                                    required
                                    id='proformainvoice-voyageNumber'
                                    label='Voyage Number'
                                    name='voyageNumber'
                                    value={payload?.voyageNumber}
                                    onChange={(
                                        e: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        updateField(
                                            'voyageNumber',
                                            e.target.value
                                        );
                                    }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </Grid>

            <Grid item xs={12} md={12} lg={6}>
                <div className='mt-4 lg:mt-0 lg:border lg:border-appcolorgreyfaint lg:px-[1rem] lg:pt-[1.1rem] lg:pb-4'>
                    <CustomTextField
                        select
                        error={errors?.countryOfFinalDestinationId.length > 0}
                        helperText={
                            errors?.countryOfFinalDestinationId.length > 0
                                ? errors?.countryOfFinalDestinationId
                                : undefined
                        }
                        required
                        id='commercialinvoice-countryOfFinalDestinationId'
                        label='Country of Final Destination'
                        name='countryOfFinalDestinationId'
                        value={payload.countryOfFinalDestinationId}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            updateField(
                                'countryOfFinalDestinationId',
                                e.target.value
                            );
                            updateField(
                                'countryOfFinalDestinationName',
                                countries.filter(
                                    (item: { id: string | number }) =>
                                        item?.id === e.target.value
                                )[0]?.name
                            );
                        }}
                    >
                        {isCountriesLoading ? (
                            <MenuItem>
                                <CircularProgress size={20} />
                            </MenuItem>
                        ) : (
                            countries.map((item) => (
                                <MenuItem
                                    value={item.id}
                                    key={`countries-${item.id}`}
                                >
                                    <div className='flex items-center'>
                                        <img
                                            src={item?.flagImageUrl}
                                            alt={`${item.name}-flag`}
                                            className='w-4 h-4'
                                        />
                                        <span className='ml-2'>
                                            {item.name}
                                        </span>
                                    </div>
                                </MenuItem>
                            ))
                        )}
                    </CustomTextField>
                </div>
            </Grid>
        </Grid>
    );
};

export default TransportDetails;
